import { X } from 'lucide-react'
import { useToastStore } from '@/lib/toastStore'

/** Renders the transient toast stack (bottom-right). Mounted once, near the app root. */
export default function Toaster() {
  const toasts = useToastStore((s) => s.toasts)
  const dismiss = useToastStore((s) => s.dismiss)
  if (toasts.length === 0) return null
  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 max-w-sm w-[calc(100%-2rem)]">
      {toasts.map((t) => (
        <div
          key={t.id}
          role="alert"
          className={`flex items-start gap-3 rounded-lg px-4 py-3 shadow-lg text-sm text-white ${
            t.variant === 'error' ? 'bg-red-600' : 'bg-green-600'
          }`}
        >
          <span className="flex-1 break-words">{t.message}</span>
          <button
            type="button"
            onClick={() => dismiss(t.id)}
            aria-label="Dismiss"
            className="opacity-80 hover:opacity-100 shrink-0"
          >
            <X size={15} />
          </button>
        </div>
      ))}
    </div>
  )
}
